var path = '/app-lite/grids/templates/cell.unsortable-header.html';
var html = "<div ng-class=\"{ ngSorted : !noSortVisible }\">\n    <span class=\"ngHeaderText\">{{col.displayName}}</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;